import { i18n } from '@/utils/i18n';

export const columns = {
};
